module.exports = __webpack_public_path__ + "static/media/posh_industries.c8f7fcc8.svg";